'use client';

import { useTranslations } from 'next-intl';
import { Box } from '@terra/ui-styled-system';
import { Edit03Icon } from '@terra/ui-icons';
import { IconButton } from '../../../components/icon-button';
import { Tooltip } from '../../../components/tooltip';
import {
  canEditEndpointMemory,
  type EndpointMemoryCreationMethod,
} from './can-remove-endpoint-memory';

type EndpointMemoryEditButtonProps = {
  creationMethod?: EndpointMemoryCreationMethod;
  loading: boolean;
  onEdit: () => void;
};

export function EndpointMemoryEditButton({
  creationMethod,
  loading,
  onEdit,
}: EndpointMemoryEditButtonProps) {
  const t = useTranslations('designSystem.applicationAssets.drawer.memories');
  const canEdit = canEditEndpointMemory({ creationMethod });
  const editLabel = t('editAriaLabel');
  const tooltipTitle = canEdit ? t('editTooltip') : t('systemCannotEdit');

  return (
    <Tooltip title={tooltipTitle}>
      <Box display="inline-flex">
        <IconButton
          aria-label={editLabel}
          size="xs"
          variant="ghost"
          disabled={!canEdit || loading}
          onClick={(event) => {
            event.stopPropagation();
            if (!canEdit) {
              return;
            }

            onEdit();
          }}
        >
          <Edit03Icon size={14} />
        </IconButton>
      </Box>
    </Tooltip>
  );
}
